import { createFileRoute } from '@tanstack/react-router'

import { JastipFeeSettingsPage } from '@/features/jastip-fee/components/JastipFeeSettingsPage'
import { jastipFeeConfigQueryOptions } from '@/features/jastip-fee/queries'

export const Route = createFileRoute('/_authed/settings/jastip-fee')({
  // The page renders its own retry state, so a failed preload must not throw.
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(jastipFeeConfigQueryOptions()).catch(() => undefined),
  component: JastipFeeSettingsPage,
})
